'use client'

import { AnimatePresence, motion } from 'framer-motion'
import { FilterPills } from './filter-pills'

interface CategoryOption {
  name: string
  slug: string
}

interface SortOptionDisplay {
  label: string
  value: string
}

interface FilterDrawerProps {
  isOpen: boolean
  sort: string
  sortOptions: SortOptionDisplay[]
  onSortChange: (value: string) => void
  category: string
  categories: CategoryOption[]
  onCategoryChange: (value: string) => void
  hasActiveFilters: boolean
  onClearFilters: () => void
}

export function FilterDrawer({
  isOpen,
  sort,
  sortOptions,
  onSortChange,
  category,
  categories,
  onCategoryChange,
  hasActiveFilters,
  onClearFilters,
}: FilterDrawerProps) {
  const categoryPillOptions = [
    { label: 'All', value: 'all' },
    ...categories.map((c) => ({ label: c.name, value: c.slug })),
  ]

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          id="content-filter-drawer"
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.2, ease: 'easeOut' }}
          className="overflow-hidden"
        >
          <div className="border-t border-border mx-4" />
          <div className="px-4 pt-3 pb-4 space-y-4">
            {/* Sort pills */}
            <FilterPills
              label="Sort by"
              options={sortOptions}
              value={sort}
              onChange={onSortChange}
            />

            {/* Category pills */}
            {categories.length > 0 && (
              <FilterPills
                label="Category"
                options={categoryPillOptions}
                value={category}
                onChange={onCategoryChange}
              />
            )}

            {/* Clear all */}
            {hasActiveFilters && (
              <button
                type="button"
                onClick={onClearFilters}
                className="text-xs font-medium text-foreground hover:underline cursor-pointer"
              >
                Clear all filters
              </button>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
